export const colors = {
    amber: '#fbbf24',
    green: '#4ade80'
}
